import {
  subheading,
  IconSizes,
  Spacings,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const FlowCaption: React.CSSProperties = {
  ...subheading,
  textAlign: 'center',
}

export const CloseIcon: React.CSSProperties = {
  width: IconSizes.NORMAL,
  height: IconSizes.NORMAL,
  position: 'absolute',
  right: toPx(Spacings.NORMAL),
  top: toPx(Spacings.MEDIUM_LARGE),
}
